import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import { AuthContextProvider } from "./context/AuthContext";
import "./assets/css/praveen.css"

import firebaseConfig from "./firebase-Config";
import { initializeApp } from "@firebase/app";
import { ActionsProvider } from "./context/ActionsContext";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
<ActionsProvider>
<AuthContextProvider>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </AuthContextProvider>
</ActionsProvider>
);

// Do NOT register a precaching service worker. CRA 2.x generates an old
// Workbox worker that never calls skipWaiting, which left users stuck on a
// cached old build until they cleared site data. unregister() removes any
// previously-installed worker, and the build replaces service-worker.js with a
// self-destroying one (see scripts/sw-killer.js) so every deploy reaches users
// immediately.
serviceWorkerRegistration.unregister();



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals( //  //console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
